// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import preview from 'html-preview';
import { DateTime } from 'luxon';

export const getTextPreview = (text: any, limit: any) => {
  const cleanText = text.replace(/&nbsp;/g, ' ');
  // the parser always removes the parent tag, so an estimated number of characters (e.g. div) are added
  if (cleanText.length > preview(cleanText, limit).length + 11) {
    const cutText = preview(cleanText, limit);
    let isStartHtmlTag = false;
    for (let i = cutText.length - 1; i !== 0; i -= 1) {
      if (
        cutText[i] !== '>' &&
        cutText[i] !== ' ' &&
        cutText[i] !== '.' &&
        !isStartHtmlTag
      ) {
        return `${cutText.substr(0, i)}...${cutText.substr(
          i + 1,
          cutText.length
        )}`;
      }
      if (cutText[i] === '>' && !isStartHtmlTag) {
        isStartHtmlTag = true;
      } else if (cutText[i] === '<' && isStartHtmlTag) {
        isStartHtmlTag = false;
      }
    }
    return `${preview(cleanText, limit)}...`;
  }
  return cleanText;
};

export type IQueryDate = {
  dateFilterId: number | null;
  date_from: string | [];
  date_to: string | [];
};

export const handlerQueryDate = (queryDate: string) => {
  const queryData: IQueryDate = {
    dateFilterId: null,
    date_from: [],
    date_to: [],
  };

  if (queryDate.length === 2) {
    switch (true) {
      // today
      // id from filterPriceArr
      case queryDate[0] === DateTime.now().toFormat('dd.LL.yyyy') &&
        queryDate[1] === DateTime.now().toFormat('dd.LL.yyyy'): {
        queryData.dateFilterId = 0;
        queryData.date_from = DateTime.now().toFormat('yyyy-LL-dd');
        queryData.date_to = DateTime.now().toFormat('yyyy-LL-dd');
        break;
      }
      // tomorrow
      case queryDate[0] ===
        DateTime.now().plus({ days: 1 }).toFormat('dd.LL.yyyy') &&
        queryDate[1] ===
          DateTime.now().plus({ days: 1 }).toFormat('dd.LL.yyyy'): {
        queryData.dateFilterId = 1;
        queryData.date_from = DateTime.now()
          .plus({ days: 1 })
          .toFormat('yyyy-LL-dd');
        queryData.date_to = DateTime.now()
          .plus({ days: 1 })
          .toFormat('yyyy-LL-dd');
        break;
      }
      // weekdays
      case queryDate[0] ===
        DateTime.local().startOf('week').toFormat('dd.LL.yyyy') &&
        queryDate[1] ===
          DateTime.local()
            .startOf('week')
            .plus({ days: 4 })
            .toFormat('dd.LL.yyyy'): {
        queryData.dateFilterId = 2;
        queryData.date_from = DateTime.local()
          .startOf('week')
          .toFormat('yyyy-LL-dd');
        queryData.date_to = DateTime.local()
          .startOf('week')
          .plus({ days: 4 })
          .toFormat('yyyy-LL-dd');
        break;
      }
      // weekend
      case queryDate[0] ===
        DateTime.local()
          .startOf('week')
          .plus({ days: 5 })
          .toFormat('dd.LL.yyyy') &&
        queryDate[1] ===
          DateTime.local()
            .startOf('week')
            .plus({ days: 6 })
            .toFormat('dd.LL.yyyy'): {
        queryData.dateFilterId = 3;
        queryData.date_from = DateTime.local()
          .startOf('week')
          .plus({ days: 5 })
          .toFormat('yyyy-LL-dd');
        queryData.date_to = DateTime.local()
          .startOf('week')
          .plus({ days: 6 })
          .toFormat('yyyy-LL-dd');
        break;
      }
      // on next week
      case queryDate[0] ===
        DateTime.local()
          .startOf('week')
          .plus({ days: 7 })
          .toFormat('dd.LL.yyyy') &&
        queryDate[1] ===
          DateTime.local()
            .startOf('week')
            .plus({ days: 13 })
            .toFormat('dd.LL.yyyy'): {
        queryData.dateFilterId = 4;
        queryData.date_from = DateTime.local()
          .startOf('week')
          .plus({ days: 7 })
          .toFormat('yyyy-LL-dd');
        queryData.date_to = DateTime.local()
          .startOf('week')
          .plus({ days: 13 })
          .toFormat('yyyy-LL-dd');
        break;
      }
      default:
        queryData.dateFilterId = null;
        queryData.date_from = DateTime.fromFormat(
          queryDate[0],
          'dd.LL.yyyy'
        ).toFormat('yyyy-LL-dd');
        queryData.date_to = DateTime.fromFormat(
          queryDate[1],
          'dd.LL.yyyy'
        ).toFormat('yyyy-LL-dd');
    }
  }
  return queryData;
};

export const setCacheControlHeader = (context: {
  res: { setHeader: (a: string, b: string) => void };
}) => {
  context.res.setHeader(
    'Cache-Control',
    'private, s-maxage=10, stale-while-revalidate=59'
  );
  context.res.setHeader('Vary', 'Cookie');
};

export default function objectToGetParams(object: {
  [key: string]: string | number | undefined | null;
}) {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );

  return params.length > 0 ? `?${params.join('&')}` : '';
}
